<template>
    <div class="cost-summary">

        <sidebar-get-in-touch />

        <div>
            <h3>Cost Summary</h3>

            <div v-if="!orderDetail" class="text-center">
                <loading-icon></loading-icon>
                <p>Calculating...</p>
            </div>

            <ul v-if="(type.toUpperCase() === 'BCH')">
                <li v-if="orderDetail"><span class="key">Contract Term</span><span class="value">{{ orderDetail.contractTerm }} Months</span></li>
                <li v-if="orderDetail"><span class="key">Total Mileage</span><span class="value">{{ orderDetail.contractDistance }}</span></li>
                <li v-if="orderDetail"><span class="key">Average Monthly BIK ()%</span><span class="value">  </span></li>
                <li v-if="orderDetail"><span class="key">Business Fuel Cost</span><span class="value">£{{ businessFuelCost}}</span></li>
                <li v-if="orderDetail"><span class="key">Private Fuel Cost</span><span class="value">£{{ privateFuelCost }}</span></li>

                <li v-if="orderDetail"><span class="key">Total Cost</span><span class="value">£{{ totalCosts }}</span></li>

                <li v-if="orderDetail"><span class="key">Business Fuel Reimbursement</span><span class="value">-£{{ businessFuelReimbursement }}</span></li>

                <li v-if="orderDetail"><span class="key">Monthly Net Cost</span><span class="value">£{{ Number(orderDetail.quote.details.pricing.totalIncVAT).toFixed(2) }}</span></li>
            </ul>

            <ul v-if="(type.toUpperCase() === 'PCH')">
                <li v-if="orderDetail"><span class="key">Contract Term</span><span class="value">{{ orderDetail.contractTerm }} Months</span></li>
                <li v-if="orderDetail" class="total-mileage"><span class="key">Total Mileage</span><span class="value">{{ orderDetail.contractDistance }}</span></li>
                <li v-if="orderDetail"><span class="key">{{appString('general.monthly-rental-cost', 'Estimated Total Rental')}}</span><span class="value">£{{ monthlyVehiclePayment }}</span></li>
                <li v-if="orderDetail"><span class="key">Insurance Cost</span><span class="value">£{{ vehicleInsurance }}</span></li>
                <li v-if="orderDetail"><span class="key">Business Fuel Cost</span><span class="value">£{{ businessFuelCost}}</span></li>
                <li v-if="orderDetail" class="total-motoring-expenses"><span class="key">Total Motoring Expenses</span><span class="value">£{{ totalCosts }}</span></li>
            </ul>

            <p v-if="(type.toUpperCase() === 'PCH') && orderDetail" class="motoring-expenses">The Motoring Expenses are funded by the below amounts:</p>

            <ul v-if="(type.toUpperCase() === 'PCH')">
                <li v-if="orderDetail" class="business-fuel-reimbursement"><span class="key">Business Fuel Reimbursement</span><span class="value">-£{{ businessFuelReimbursement }}</span></li>
                <!--<li v-if="orderDetail" class="negative"><span class="key">Mileage Allowance Relief</span><span class="value">-£{{ businessMileageAllowance }}</span></li>-->
                <li v-if="orderDetail" class="cash-allowance-net"><span class="key">Cash Allowance – Net</span><span class="value">-£{{ cashAllowanceNet }}</span></li>
                <li v-if="orderDetail" class="your-contribution-estimated"><span class="key">Your Contribution - Estimate</span><span class="value">-£{{ cashAllowanceNet }}</span></li>
                <li v-if="orderDetail" class="total-monthly-net-cost"><span class="key">Total Monthly Net Cost</span><span class="value">£{{ netTotal }}</span></li>
                <li v-if="orderDetail" class="private-fuel-cost"><span class="key">Private Fuel Cost</span><span class="value">£76.00</span></li>
                <li v-if="orderDetail && appClient === 'TravisPerkins'" class="optional-final-balloon-payment"><span class="key">Optional Final Balloon Payment</span><span class="value">£{{ optionalBalloon }}</span></li>
            </ul>

        </div>



        <div v-if="(type.toUpperCase() === 'BCH')">

            <template v-if="appClient === 'Origo'">
                <section class="mb-4">
                    <h3>Employee Declarations</h3>
                    <h4>I confirm that:</h4>
                    <div class="checkbox">
                        <input type="checkbox" name="employee-details" id="employee-details" class="employee-details" v-model="confirmations.employeeDetails" disabled>
                        <label for="employee-details" class="multiple-lines">These are my employee details</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.keyPolicyPoints" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I have read and accept the key policy points.</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.correctVehicle" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I have selected the correct vehicle<br/> and vehicle options</label>
                    </div>
                </section>
            </template>
            <template v-if="appClient === 'TravisPerkins'">
                <section class="mb-4">
                    <h3>Employee Declarations</h3>
                    <h4>I confirm that:</h4>
                    <div class="checkbox">
                        <input type="checkbox" name="employee-details" id="employee-details" class="employee-details" v-model="confirmations.employeeDetails" disabled>
                        <label for="employee-details" class="multiple-lines">These are my employee details</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.keyPolicyPoints" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I have read and accept the key policy points.</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.correctVehicle" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I have selected the correct vehicle<br/> and vehicle options</label>
                    </div>
                </section>
            </template>



        </div>

        <div v-else>

            <template v-if="appClient === 'Origo'">
                <section class="mb-4">
                    <h3>Employee Declarations</h3>
                    <h4>I confirm that:</h4>
                    <div class="checkbox">
                        <input type="checkbox" name="employee-details" id="employee-details" class="employee-details" v-model="confirmations.employeeDetails" disabled>
                        <label for="employee-details" class="multiple-lines">These are my employee details</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="direct-debit" id="direct-debit" class="direct-debit" v-model="confirmations.directDebitPayment" disabled>
                        <label for="direct-debit" class="multiple-lines">I accept the monthly charge taken by direct debit for the provision of the vehicle.</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.salaryDeductions" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I accept that the above will be deducted from my salary for the provision of the vehicle.</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.correctVehicle" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I have selected the correct vehicle<br/> and vehicle options</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="personal-contract-hire-arrangement" id="personal-contract-hire-arrangement" class="personal-contract-hire-arrangement" v-model="confirmations.onlyIncludedOnPersonalContractHireAgreement" disabled>
                        <label for="personal-contract-hire-arrangement" class="multiple-lines">I’ve selected the correct products<br/> as part of the Personal Contract<br/> Hire Arrangement</label>
                    </div>
                </section>


                <section class="mb-4" v-if="stepOneAgreed">
                    <h3>Available Products</h3>

                    <h4>I confirm that:</h4>

                    <div class="checkbox">
                        <input type="checkbox" name="privacy-policy" id="privacy-policy" class="privacy-policy" v-model="confirmations.maintenanceProduct" disabled>
                        <label for="privacy-policy" class="multiple-lines">Maintanence product agreement confirmed</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="corporate-policy" id="corporate policy" class="corporate policy" v-model="confirmations.motorInsuranceProduct" disabled>
                        <label for="corporate policy" >Motor insurance product agreement confirmed</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="policy-three" id="policy-three" class="policy-three" v-model="confirmations.earlyTerminationProduct" disabled>
                        <label for="policy-three" >Early termination product confirmed</label>
                    </div>
                </section>

                <section class="mb-4" v-if="stepTwoAgreed">

                    <h3>Policies</h3>

                    <h4>I confirm that:</h4>

                    <div class="checkbox">
                        <input type="checkbox" name="privacy-policy" id="privacy-policy" class="privacy-policy" v-model="confirmations.privacyNotice" disabled>
                        <label for="privacy-policy" class="multiple-lines">Website & communications privacy notice confirmed</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="corporate-policy" id="corporate policy" class="corporate policy" v-model="confirmations.keyPolicyPoints" disabled>
                        <label for="corporate policy">Key policy points confirmed</label>
                    </div>


                </section>

            </template>

            <template v-if="appClient === 'TravisPerkins'">

                <section class="mb-4">
                    <h3>Employee Declarations</h3>
                    <h4>I confirm that:</h4>
                    <div class="checkbox">
                        <input type="checkbox" name="employee-details" id="employee-details" class="employee-details" v-model="confirmations.employeeDetails" disabled>
                        <label for="employee-details" class="multiple-lines">These are my employee details</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options" class="vehicle-and-vehicle-options" v-model="confirmations.correctVehicle" disabled>
                        <label for="vehicle-and-vehicle-options" class="multiple-lines">I have selected the correct vehicle<br/> and vehicle options</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="personal-contract-hire-arrangement" id="personal-contract-hire-arrangement" class="personal-contract-hire-arrangement" v-model="confirmations.creditSaleDetails" disabled>
                        <label for="personal-contract-hire-arrangement" class="multiple-lines">I have accepted the contract term, mileage and monthly vehicle payment</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="further-salary-deductions" id="further-salary-deductions" class="further-salary-deductions" v-model="confirmations.furtherSalaryDeductions" disabled>
                        <label for="further-salary-deductions" class="multiple-lines">I have accepted the value that will be deducted from my salary</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="maintenance-key-points" id="maintenance-key-points" class="maintenance-key-points" v-model="confirmations.fullVehicleMaintenance" disabled>
                        <label for="maintenance-key-points">I have accepted the key maintenance points</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="insurance-key-points" id="insurance-key-points" class="insurance-key-points" v-model="confirmations.motorInsuranceProduct" disabled>
                        <label for="insurance-key-points" class="multiple-lines">I have accepted the key insurance points</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="early-termination-points" id="early-termination-points" class="early-termination-points" v-model="confirmations.earlyTerminationInsurance" disabled>
                        <label for="early-termination-points">I have accepted the key early termination insurance points</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="key-points" id="key-points" class="key-points" v-model="confirmations.schemePolicy" disabled>
                        <label for="key-points">Key policy points confirmed</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="privacy-policy" id="privacy-policy" class="privacy-policy" v-model="confirmations.privacyNotice" disabled>
                        <label for="privacy-policy" class="multiple-lines">Website & communications privacy notice confirmed</label>
                    </div>

                </section>
            </template>



        </div>



    </div>

</template>

<script>
    import LoadingIcon from "../loading-icon";
    import SidebarGetInTouch from "../sidebar-get-in-touch";
    export default {
        components: {SidebarGetInTouch, LoadingIcon},
        data() {
          return{
              appClient: process.env.MIX_APP_CLIENT,
          }
        },
        props: {
            confirmations: null,
            orderDetail: null,
            driverProfile: null,
            type: null,
        },
        watch: {
            confirmations(value) {
                // this.$parent.confirmations = value;
            },
            orderDetail(value) {
                // console.debug("order detail", value);
            }
        },
        computed: {

            vehicleCosts() {
                if (!this.driverProfile || !this.quote) {
                    return {}
                }

                let vehicleCosts = {
                    vehiclePayment: (Number(this.getMonthlyVehiclePayment(this.quote)).toFixed(2)),
                    insuranceProduct: (Number(this.quote.quote.taxCalculations.employeeCostPrivateCar.motoringAndFinance_InsuranceCost) / this.quote.term).toFixed(2),
                    approvedMileageAllowance: Number(this.driverProfile.contacts[0].telephoneNumber1).toFixed(2),
                    cashAllowance: Number(this.getCashAllowanceNet(this.quote)).toFixed(2),
                    standardGradeDriverContribution: Number(this.driverProfile.contacts[0].telephoneNumber2).toFixed(2),
                    costAsTraditionalCompanyCar: Number(this.getTraditionalCarCost(this.quote)).toFixed(2),
                    businessFuelCost: (Number(this.quote.quote.taxCalculations.employeeCostPrivateCar.businessMileage_BusinessFuelCost) / this.quote.term).toFixed(2),
                    privateFuelCost: (Number(this.quote.quote.taxCalculations.employeeCostPrivateCar.privateMileage_PrivateFuelCost) / this.quote.term).toFixed(2),
                    businessFuelReimbursement: Number(Math.abs(this.quote.quote.taxCalculations.employeeCostCompanyCar.businessMileage_BusinessMileageAllowance) / this.quote.term).toFixed(2),
                    optionalFinalBalloonPayment: Number(this.quote.quote.details.pricing.balloonPaymentIncVAT).toFixed(2)
                }
                vehicleCosts.totalMotoringExpenses = Number(Number(vehicleCosts.vehiclePayment) + Number(vehicleCosts.insuranceProduct)).toFixed(2)
                vehicleCosts.totalMotoringAmounts = Number(Number(vehicleCosts.approvedMileageAllowance) + Number(vehicleCosts.cashAllowance)).toFixed(2)
                vehicleCosts.netMonthlyCost = Number(Number(vehicleCosts.totalMotoringExpenses) - Number(vehicleCosts.totalMotoringAmounts)).toFixed(2)
                vehicleCosts.netFuelCost = Number(Number(vehicleCosts.businessFuelCost) + Number(vehicleCosts.privateFuelCost) + Number(vehicleCosts.businessFuelReimbursement)).toFixed(2)

                vehicleCosts.tradeUpTradeDown = Number(Number(vehicleCosts.netMonthlyCost) - Number(vehicleCosts.standardGradeDriverContribution)).toFixed(2)

                return vehicleCosts
            },


            stepOneAgreed() {
                switch(this.appClient){
                    case 'Origo':
                        return ( this.confirmations.employeeDetails &&
                            this.confirmations.directDebitPayment &&
                            this.confirmations.salaryDeductions &&
                            this.confirmations.correctVehicle &&
                            this.confirmations.onlyIncludedOnPersonalContractHireAgreement );
                        break;
                    case 'TravisPerkins':
                        return ( this.confirmations.employeeDetails &&
                            this.confirmations.salaryDeductions &&
                            this.confirmations.correctVehicle );
                        break;
                }
            },
            stepTwoAgreed() {
                switch(this.appClient){
                    case 'Origo':
                        return (
                            this.confirmations.maintenanceProduct &&
                            this.confirmations.motorInsuranceProduct &&
                            this.confirmations.earlyTerminationProduct );
                        break;
                    case 'TravisPerkins':
                        return (
                            this.confirmations.maintenanceProduct &&
                            this.confirmations.motorInsuranceProduct );
                        break;
                }
            },
            stepThreeAgreed() {
                switch(this.appClient){
                    case 'Origo':
                        return (
                            this.confirmations.privacyNotice &&
                            this.confirmations.keyPolicyPoints );
                        break;
                    case 'TravisPerkins':
                        return (
                            this.confirmations.privacyNotice &&
                            this.confirmations.keyPolicyPoints );
                        break;
                }
            },

            currentQuote(){
                if (!this.orderDetail.quote.taxCalculations){ return false; }
                const currentQuote = this.orderDetail.quote.taxCalculations.calculationResults.slice(-1)[0];
                return currentQuote;
            },

            cashAllowance() {
                if (this.orderDetail.quote.taxCalculations){
                    return this.getMonthlyCost(Math.abs(this.currentQuote['employeeCostPrivateCar']['cashAllowanceReconciliation_CashAllowance']));
                }
                return 'Unknown';
            },

            businessFuelCost() {
                if (this.orderDetail.quote.taxCalculations){
                    if (this.type === 'BCH'){
                        return this.getMonthlyCost(this.currentQuote['employeeCostCompanyCar']['businessMileage_BusinessFuelCost'])
                    }
                    return this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['businessMileage_BusinessFuelCost'])
                }
                return 'Unknown';
            },

            privateFuelCost() {
                if (this.orderDetail.quote.taxCalculations){
                    if (this.type === 'BCH'){
                        return this.getMonthlyCost(this.currentQuote['employeeCostCompanyCar']['privateMileage_PrivateFuelCost']);
                    }
                    return this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['privateMileage_PrivateFuelCost']);
                }
                return 'Unknown';
            },


            businessFuelReimbursement() {
                if (this.orderDetail.quote.taxCalculations){
                    return Math.abs(this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['businessMileage_BusinessMileageAllowance']));
                }
                return 'Unknown';
            },


            businessMileageAllowance() {
                if (this.orderDetail.quote.taxCalculations){
                    return Math.abs(this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['businessMileage_TaxReliefOnBusinessMileageCostAndAL']));
                }
                return 'Unknown';
            },

            cashAllowanceNet() {
                if (this.orderDetail.quote.taxCalculations){
                    const cashAllowance = Number(this.cashAllowance);
                    const cashIncomeTax = Number(this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['cashAllowanceReconciliation_IncomeTaxOnCashAlternative']));
                    const cash1NIC = Number(this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['cashAllowanceReconciliation_Class1NICOnCashAllowance']));
                    return Number(cashAllowance - (cashIncomeTax + cash1NIC)).toFixed(2);
                }
                return 'Unknown';
            },

            netTotal() {

                if (this.orderDetail.quote.taxCalculations){

                    switch(this.type) {
                        case 'BCH':
                            return this.getMonthlyCost(this.currentQuote.employeeCostCompanyCar.totals_NetPresentValueNPV);
                            break;
                        case 'PCH':
                            return this.getMonthlyCost(this.currentQuote.employeeCostPrivateCar.totals_NetPresentValueNPV);
                            break;
                    }


                    // let total = 0;
                    // const totalCosts = Number(this.totalCosts);
                    // const businessFuelReimbursement = Number(this.businessFuelReimbursement);
                    // const businessMileageAllowance = Number(this.businessMileageAllowance);
                    // const cashAllowanceNet = Number(this.cashAllowanceNet);
                    //
                    // total = (totalCosts - (businessFuelReimbursement + businessMileageAllowance + cashAllowanceNet));
                    //
                    // return Number(total).toFixed(2);
                }
                return 'Unknown';
            },

            optionalBalloon() {
                if (this.orderDetail.quote){
                    return Number(this.orderDetail.quote.details.pricing.balloonPaymentIncVAT).toFixed(2);
                }
                return 'Unknown';
            },

            monthlyVehiclePayment(){
                if (!this.orderDetail.quote.taxCalculations){ return false; }
                const rentalsPayment = this.currentQuote['employeeCostPrivateCar']['motoringAndFinance_RentalsPayments'];
                const maintenanceCost = this.currentQuote['employeeCostPrivateCar']['motoringAndFinance_MaintenanceCost'];

                return this.getMonthlyCost(rentalsPayment + maintenanceCost);
            },

            vehicleInsurance(){
                if (!this.orderDetail.quote.taxCalculations){ return false; }
                return this.getMonthlyCost(this.currentQuote['employeeCostPrivateCar']['motoringAndFinance_InsuranceCost']);
            },

            totalCosts() {
                let total = 0;
                const monthlyPayment = Number(this.monthlyVehiclePayment);
                const businessFuelCost = Number(this.businessFuelCost);
                const privateFuelCost = Number(this.privateFuelCost);
                const vehicleInsurance = Number(this.vehicleInsurance);

                switch (this.type) {
                    case 'BCH':
                        total = monthlyPayment + businessFuelCost + privateFuelCost;
                        break;
                    case 'PCH':
                        total = monthlyPayment + businessFuelCost + privateFuelCost + vehicleInsurance;
                        break;
                }
                return Number(total).toFixed(2);
            },



        },

        methods:{
            getMonthlyCost(value){
                return (Number(value) / this.orderDetail.contractTerm).toFixed(2);
            }
        }
    };
</script>
